import { filterTalksByTab } from '../../constants/qoreTalks';

export const LISTENING_KEY = 'qoretalks-listen-progress';

export function applyTalkFilters(talks, { tabIndex, category, search, liveRoomCount = 0 }) {
  let list = filterTalksByTab(talks, tabIndex, liveRoomCount);
  if (category && category !== 'all') {
    list = list.filter((t) => t.category === category);
  }
  const q = (search || '').trim().toLowerCase();
  if (q) {
    list = list.filter(
      (t) =>
        (t.title || '').toLowerCase().includes(q) ||
        (t.description || '').toLowerCase().includes(q) ||
        (t.host?.name || '').toLowerCase().includes(q) ||
        (t.tags || []).some((tag) => String(tag).toLowerCase().includes(q))
    );
  }
  return list;
}

export function pickFeaturedTalk(talks) {
  if (!talks?.length) return null;
  const published = talks.filter((t) => t.status === 'published' && !t.isLive);
  const pool = published.length ? published : talks;
  return [...pool].sort((a, b) => {
    const va = a.analytics?.views || 0;
    const vb = b.analytics?.views || 0;
    if (vb !== va) return vb - va;
    return new Date(b.publishedAt || 0) - new Date(a.publishedAt || 0);
  })[0];
}

export function getRelatedTalks(talks, currentId, limit = 3) {
  const current = talks.find((t) => (t._id || t.id) === currentId);
  if (!current) return talks.filter((t) => (t._id || t.id) !== currentId).slice(0, limit);
  return talks
    .filter((t) => (t._id || t.id) !== currentId && t.status === 'published')
    .sort((a, b) => {
      const sameCat = (t) => (t.category === current.category ? 1 : 0);
      return sameCat(b) - sameCat(a);
    })
    .slice(0, limit);
}

export function saveListeningProgress(episodeId, currentTime, duration) {
  try {
    localStorage.setItem(
      LISTENING_KEY,
      JSON.stringify({
        episodeId,
        currentTime,
        duration,
        updatedAt: Date.now(),
      })
    );
  } catch {
    /* ignore quota */
  }
}

export function getListeningProgress() {
  try {
    const raw = localStorage.getItem(LISTENING_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearListeningProgress(episodeId) {
  const p = getListeningProgress();
  if (p?.episodeId === episodeId) {
    localStorage.removeItem(LISTENING_KEY);
  }
}

export const PLATFORM_LINKS = [
  { name: 'Spotify', key: 'spotify', url: process.env.REACT_APP_QT_SPOTIFY_URL || '', color: '#1DB954' },
  { name: 'Apple Podcasts', key: 'apple', url: process.env.REACT_APP_QT_APPLE_URL || '', color: '#A855F7' },
  { name: 'YouTube', key: 'youtube', url: process.env.REACT_APP_QT_YOUTUBE_URL || '', color: '#FF0000' },
  { name: 'Google Podcasts', key: 'google', url: process.env.REACT_APP_QT_GOOGLE_URL || '', color: '#4285f4' },
  { name: 'RSS', key: 'rss', url: '', color: '#f97316' },
];

export function getRssFeedUrl() {
  const base = process.env.REACT_APP_API_BASE || 'https://qorenova-backend-production.up.railway.app';
  return `${base}/api/qoretalks/feed`;
}